var InvitedList = [
  {
    id: 0,
    name: 'David Smith',
    image: 'david',
    affiliation: 'PS Research',
    link: 'http://psresearch.xyz/',
  },
  {
    id: 1,
    name: 'Ron Petrick',
    image: 'ronpetrick',
    affiliation: 'Heriot-Watt University.',
    link: 'https://www.macs.hw.ac.uk/~rpp6/',
  },
  {
    id: 2,
    name: 'Daniel Höller',
    image: 'danielhoeller',
    affiliation: 'Saarland University',
    link: 'http://fai.cs.uni-saarland.de/hoeller/',
  },
];

var PanelList = [];

var OrganizingTeamList = [
  {
    id: 1,
    name: 'Rebecca Eifler',
    image: 'rebecca',
    affiliation: 'Saarland University',
    link: 'http://fai.cs.uni-saarland.de/eifler/',
  },
  {
    id: 2,
    name: 'Benjamin Krarup',
    image: 'ben',
    affiliation: 'Kings College London',
    link: 'https://uk.linkedin.com/in/benjamin-krarup',
  },
  {
    id: 3,
    name: 'Alan Lindsay',
    image: 'alanL',
    affiliation: 'Heriot-Watt University',
    link: 'https://researchportal.hw.ac.uk/en/persons/alan-lindsay',
  },
  {
    id: 4,
    name: 'Lindsay Sanneman',
    image: 'lindsay',
    affiliation: 'MIT',
    link: 'https://www.lindsaysanneman.com/',
  },
  {
    id: 5,
    name: 'Sarath Sreedharan',
    image: 'sarath',
    affiliation: 'Colorado State University',
    link: 'http://sarathsreedharan.com/',
  },
  {
    id: 6,
    name: 'Silvia Tulli',
    image: 'silvia',
    affiliation: 'Sorbonne University',
    link: 'https://silviatulli.com/',
  },
  {
    id: 7,
    name: 'Stylianos Vasileiou',
    image: 'stylianos',
    affiliation: 'Washington University',
    link: 'https://thestlucas.com/',
  },
];

var SteeringCommitteeList = [
  {
    id: 8,
    name: 'Jeremy Frank',
    image: 'frank',
    affiliation: 'NASA',
    link: 'https://www.nasa.gov/content/jeremy-frank',
  },
  {
    id: 9,
    name: 'Claudia Goldman',
    image: 'claudia',
    affiliation: 'General Motors',
    link: 'https://il.linkedin.com/in/claudiagoldman',
  },
  {
    id: 10,
    name: 'Jörg Hoffmann',
    image: 'joerg',
    affiliation: 'Saarland University',
    link: 'http://fai.cs.uni-saarland.de/hoffmann/',
  },
  {
    id: 11,
    name: 'Subbarao Kambhampati',
    image: 'rao',
    affiliation: 'Arizona State University',
    link: 'https://rakaposhi.eas.asu.edu/',
  },
  {
    id: 6,
    name: 'David Smith',
    image: 'david',
    affiliation: 'PS Research',
    link: 'http://psresearch.xyz/',
  },
  {
    id: 7,
    name: 'William Yeoh',
    image: 'william',
    affiliation: 'Washington University in St. Louis',
    link: 'https://sites.wustl.edu/wyeoh/',
  },
];

var PCListCache = [
  {
    id: 1,
    name: 'Devleena Das',
    affiliation: 'Georgia Institute of Technology',
  },
  {
    id: 2,
    name: 'Sriram Gopalakrishnan',
    affiliation: 'Arizona State University',
  },
  {
    id: 3,
    name: 'Karthik Valmeekam',
    affiliation: 'Arizona State University',
  },
  {
    id: 4,
    name: 'Christabel Wayllace',
    affiliation: 'University of Alberta',
  },
  {
    id: 5,
    name: 'Mudit Verma',
    affiliation: 'Arizona State University',
  },
  {
    id: 6,
    name: 'Songtuan Lin',
    affiliation: 'Australian National University',
  },
  {
    id: 7,
    name: 'Pulkit Verma',
    affiliation: 'Arizona State University',
  },
  {
    id: 8,
    name: 'Miguel Faria',
    affiliation: 'Autonomous University of Lisbon',
  },
  {
    id: 9,
    name: 'Rohan R Paleja',
    affiliation: 'Georgia Tech',
  },
  {
    id: 10,
    name: 'Gerard Canal',
    affiliation: 'Kings College London',
  },
  {
    id: 11,
    name: 'Senka Krivic',
    affiliation: 'University of Sarajevo',
  },
  {
    id: 12,
    name: 'Michael S. Lee',
    affiliation: 'Carnegie Mellon University',
  },
  {
    id: 13,
    name: 'Siddhant Bhambri',
    affiliation: 'Arizona State University',
  },
  {
    id: 14,
    name: 'Daniel Fišer',
    affiliation: 'Saarland University',
  },
  {
    id: 15,
    name: 'Derek Long',
    affiliation: 'Kings College London',
  },
  {
    id: 15,
    name: 'Andrew Coles',
    affiliation: 'Kings College London',
  },
  {
    id: 16,
    name: 'David E Smith',
    affiliation: 'PS Research',
  },
  {
    id: 17,
    name: 'Ashwin Kumar',
    affiliation: 'Washington University in St. Louis',
  },
  {
    id: 18,
    name: 'Pascal Bercher',
    affiliation: 'Australian National University',
  },
];

var ProjectList = [
  {
    id: 8,
    name: 'TUPLES',
    image: 'tuples',
    link: 'https://tuples.ai/',
  },
];

export {
  OrganizingTeamList,
  SteeringCommitteeList,
  PCListCache,
  InvitedList,
  PanelList,
  ProjectList,
};
